module.exports = __webpack_public_path__ + "media/images/icons/flags/MN-567f7ec9714e729e4ac038ad22172e99.svg";